import { Col, Row, Typography, Tooltip, Divider } from "antd";
import { FormItem, Input, Select, DatePicker } from "formik-antd";
import React, { useState } from "react";
import { UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  StyledFormikResetButton,
  StyledFormikSubmitButton,
} from "../styled-components/components";
import countryList from "../../data/countryList.json";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import moment from "moment";

export const FormikEmailInput = (props) => {
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        {props.prefix ? (
          <Row style={{ marginBottom: "1vh" }}>
            <Typography.Text>Email</Typography.Text>
          </Row>
        ) : null}
        <Row>
          <Input
            style={{ height: "48px" }}
            data-testid="email"
            autoComplete="none"
            type="email"
            name={props.name}
            placeholder="Enter email address"
            prefix={props.prefix ? null : <UserOutlined />}
          ></Input>
        </Row>
      </FormItem>
    </Col>
  );
};

export const FormikPassword = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Col>
            <Typography.Text>
              {props.label ? props.label : "Password"}
            </Typography.Text>
          </Col>
          <Col style={{ marginLeft: "1vh" }}>
            {props.icon ? (
              <Tooltip title="Password should contain one Uppercase,one Lowercase,one Number,one Special Character and minimum of 8 letters">
                <InfoCircleOutlined />
              </Tooltip>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Input
            autoComplete="none"
            data-testid="password"
            style={{ height: "48px" }}
            type={showPassword ? "text" : "password"}
            name={props.name}
            placeholder="Enter Password"
            suffix={
              props.suffix ? (
                <Col>
                  {showPassword ? (
                    <Col>
                      <EyeInvisibleOutlined
                        onClick={() => setShowPassword(false)}
                      />
                    </Col>
                  ) : (
                    <Col>
                      <EyeOutlined onClick={() => setShowPassword(true)} />
                    </Col>
                  )}
                </Col>
              ) : null
            }
          ></Input>
        </Row>
      </FormItem>
    </Col>
  );
};

export const FormikSubmitButton = (props) => {
  return (
    <Col style={{ height: "48px" }}>
      <StyledFormikSubmitButton
        data-testid={props.id}
        disabled={props.disabled}
        style={{
          width: "100%",
          height: "100%",
          color: "#ffffff",
          backgroundColor: `${props.disabled ? "#68A3F8" : "#1565D8"}`,
        }}
      >
        {props.name}
      </StyledFormikSubmitButton>
    </Col>
  );
};

export const FormikResetButton = (props) => {
  return (
    <Col style={{ height: "48px" }}>
      <StyledFormikResetButton
        data-testid={props.id}
        disabled={props.disabled}
        style={{
          width: "100%",
          height: "100%",
          color: "#ffffff",
          // backgroundColor: `${props.disabled ? "#68A3F8" : "#1565D8"}`,
        }}
      >
        {props.name}
      </StyledFormikResetButton>
    </Col>
  );
};

export const FormikInput = (props) => {
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>{props.label}</Typography.Text>
        </Row>
        <Row>
          <Input
            autoComplete="none"
            data-testid={props.id}
            disabled={props.disabled ? props.disabled : false}
            defaultValue={props.value}
            type={props.type ? props.type : "text"}
            style={{ height: "48px" }}
            name={props.name}
            placeholder={props.placeholder}
            prefix={
              props.prefix ? (
                <Col>
                  {props.prefix} <Divider type="vertical"></Divider>
                </Col>
              ) : null
            }
          ></Input>
        </Row>
      </FormItem>
    </Col>
  );
};

export const SelectCountry = (props) => {
  const allCountries = countryList.map((country) => (
    <Select.Option key={country.code} value={country.name}>
      {country.name}
    </Select.Option>
  ));
  const setCountry = (countryValue) => {
    const country = countryList.find(
      (countryMobile) => countryMobile.name === countryValue
    );
    if (country) {
      props.getCountryCode(country.telephoneCode);
    } else {
      props.getCountryCode("+91");
    }
  };
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>{props.label}</Typography.Text>
        </Row>
        <Row>
          <Select
            autoComplete="none"
            data-testid={props.id}
            name={props.name}
            showSearch
            allowClear
            size="large"
            onChange={setCountry}
            placeholder={props.placeholder}
            defaultValue={props.value}
          >
            {allCountries}
          </Select>
        </Row>
      </FormItem>
    </Col>
  );
};

export const FormikT24Select = (props) => {
  const options = props.options.map((option) => (
    <Select.Option key={option.id} value={option.id}>
      {option.T24Release}-{option.CurrentStatus}
    </Select.Option>
  ));
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>{props.label}</Typography.Text>
        </Row>
        <Row>
          <Select
            autoComplete="none"
            data-testid={props.id}
            style={{ marginBottom: "1vh" }}
            name={props.name}
            showSearch
            allowClear
            size="large"
            disabled={props.disabled ? props.disabled : false}
            placeholder={props.placeholder}
          >
            {options}
          </Select>
        </Row>
      </FormItem>
    </Col>
  );
};

export const FormikSelect = (props) => {
  const options = props.options.map((option) => (
    <Select.Option key={option.value} value={option.value}>
      {option.label}
    </Select.Option>
  ));
  const setStatus = (value) => {
    if (props.callBack) {
      props.getStatus(value);
    }
  };
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>{props.label}</Typography.Text>
        </Row>
        <Row>
          <Select
            autoComplete="none"
            data-testid={props.id}
            style={{ marginBottom: "1vh" }}
            name={props.name}
            showSearch
            allowClear
            size="large"
            onChange={setStatus}
            disabled={props.disabled ? props.disabled : false}
            placeholder={props.placeholder}
          >
            {options}
          </Select>
        </Row>
      </FormItem>
    </Col>
  );
};

export const FormikDate = (props) => {
  return (
    <Col xs={{ span: 24 }} style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>{props.label}</Typography.Text>
        </Row>
        <Row>
          <DatePicker
            // superNextIcon={<CaretRightOutlined />}
            data-testid={props.id}
            disabled={props.disabled}
            defaultValue={props.value ? moment(props.value, "YYYY-MM-DD") : ""}
            style={{ height: "48px", width: "100%" }}
            id={props.name}
            name={props.name}
            placeholder={props.placeholder ? props.placeholder : "Select Date"}
          ></DatePicker>
        </Row>
      </FormItem>
    </Col>
  );
};

export const FormikTextArea = (props) => {
  return (
    <Col style={{ marginBottom: "1vh" }}>
      <FormItem name={props.name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>{props.label}</Typography.Text>
        </Row>
        <Row>
          <Input.TextArea
            autoComplete="none"
            rows={4}
            defaultValue={props.value}
            style={{ height: "96px" }}
            name={props.name}
            data-testid={props.id}
            placeholder={
              props.placeholder
                ? props.placeholder
                : "Enter Additional Comments"
            }
          ></Input.TextArea>
        </Row>
      </FormItem>
    </Col>
  );
};
